import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {BaseFillDataFormComponent} from '../widgets/form-section/base-fill-data-form-component';
import {ClauseSubtype} from './clause-subtype.enum';
import {ClauseTag} from './clause-tag.enum';
import {ClauseType} from './clause-type.enum';
import {CustomValidators} from '../core/validator/custom-validators';
import {IncludeCompanyType} from './include-company-type.enum';

@Component({
  selector: 'app-clause-item',
  templateUrl: './clause-item.component.html'
})
export class ClauseItemComponent extends BaseFillDataFormComponent implements OnInit, OnDestroy {

  clauseForm: FormGroup;
  dateForm: FormGroup;
  clauseTypes: ClauseType[];
  clauseSubtypes: ClauseSubtype[];
  clauseTags: ClauseTag[];
  includeCompanyTypes: IncludeCompanyType[];
  clausesMapping: number[][];
  firstClauseSubtype = false;

  ngOnInit() {
    this.initializeClauseTypes();
    this.initializeClauseSubtypes();
    this.initializeClauseTags();
    this.initializeIncludeCompanyTypes();
    if (this.data.subtype !== undefined) {
      this.firstClauseSubtype = true;
    }
    this.createForm();
  }

  initializeClauseTypes() {
    this.clauseTypes = [];
    for (const n in ClauseType) {
      if (typeof ClauseType[n] === 'number') {
        this.clauseTypes.push(ClauseType[ClauseType[n]]);
      }
    }
  }

  initializeClauseSubtypes() {
    this.clauseSubtypes = [];
    for (const n in ClauseSubtype) {
      if (typeof ClauseSubtype[n] === 'number') {
        this.clauseSubtypes.push(ClauseSubtype[ClauseSubtype[n]]);
      }
    }
    this.clausesMapping = [[0, 4, 7, 9], [0, 4, 7], [0, 4, 6, 7], [1], [1], [2], [3], [3], [4], [0], [5], [5], [5], [1, 8]];
  }

  initializeClauseTags() {
    this.clauseTags = [];
    for (const n in ClauseTag) {
      if (typeof ClauseTag[n] === 'number') {
        this.clauseTags.push(ClauseTag[ClauseTag[n]]);
      }
    }
  }

  initializeIncludeCompanyTypes() {
    this.includeCompanyTypes = [];
    for (const n in IncludeCompanyType) {
      if (typeof IncludeCompanyType[n] === 'number') {
        this.includeCompanyTypes = this.includeCompanyTypes.concat(IncludeCompanyType[IncludeCompanyType[n]]);
      }
    }
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl('clauseForm' + this.formIndex);
  }

  updateClauseType() {
    if (!this.firstClauseSubtype) {
      this.data.subtype = undefined;
    }
    this.firstClauseSubtype = false;

    if (this.data.type === ClauseType.IMAGE) {
      this.data.subtype = ClauseSubtype.PHOTOS;
    } else if (this.data.type === ClauseType.REGULATIONS) {
      this.data.subtype = ClauseSubtype.NO_PURPOSE;
    }
  }

  checkSubtype(i: number) {
    return this.clausesMapping[i].indexOf(this.data.type) > -1;
  }

  private createForm() {
    this.dateForm = new FormGroup({
      'provideDate': new FormControl('', [Validators.pattern(BaseFillDataFormComponent.datePattern), Validators.required]),
      'expirationDate': new FormControl('', Validators.pattern(BaseFillDataFormComponent.datePattern)),
    }, CustomValidators.validateDates('provideDate', 'expirationDate'));
    this.clauseForm = new FormGroup({
      'description': new FormControl('', CustomValidators.notEmpty),
      'type': new FormControl('', Validators.required),
      'subtype': new FormControl('', Validators.required),
      'tag': new FormControl('', Validators.required),
      'includeCompanyType': new FormControl(''),
      'date': this.dateForm
    });
    this.parentForm.addControl('clauseForm' + this.formIndex, this.clauseForm);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/clause/clause-item.component.ts